const Inview = new function () {
    let elements = []
    
    this.init = () => {
        document.querySelectorAll('[data-inview]').forEach(element => {
            elements.push({
                el: element,
                // animation: element.dataset.inview
            })
        })
    
        elements.forEach(element => {            
            ScrollTrigger.create({
                trigger: element.el,
                // toggleClass: 'is-inview',
                scroller: document.querySelector('#sn-page'),
                onEnter() {
                    element.el.classList.add('is-inview');
                },
            })
        })
    }

    
}

export default Inview